<script>
import { BASE_PLAN_SUB_TYPES, DEFAULT_MIN_HOST, DEFAULT_MAX_HOST } from '@/common/constants';
import Base from '@/plans/ZOOM_WHITEBOARD/config/base';
import { mapGetters } from 'vuex';
import { get } from 'lodash';

export default {
  name: 'WhiteboardEdit',
  extends: Base,
  computed: {
    ...mapGetters(['basicConfig', 'currentEditPlan']),
    showPlanDetails() {
      // hide plan details if the user already has both plans
      const whiteboard = this.boughtPlans.find((p) => p.category === BASE_PLAN_SUB_TYPES.WHITEBOARD_BASIC);
      const whiteboardPlus = this.boughtPlans.find((p) => p.category === BASE_PLAN_SUB_TYPES.WHITEBOARD_PLUS);
      return !(whiteboard && whiteboardPlus);
    },
    planDetailsLabel() {
      return this.$t('billing.zone.explore_other_plans_edit');
    },
    disabledForBulkLicense() {
      return (billingCycle) => {
        return this.basicConfig.isBulkLicenseAccount && get(this.currentEditPlan, ['billing_cycle'], '') !== billingCycle;
      }
    },
    previousQuantity() {
      return this.currentEditPlan?.cartInfo?.selected_number ?? DEFAULT_MIN_HOST;
    },
    minHosts() {
      if (this.disableDownSell || this.decreaseTips) return this.previousQuantity;
      return DEFAULT_MIN_HOST;
    },
    maxHosts() {
      const quantity = this.currentEditPlan?.cartInfo?.selected_number;
      return quantity <= DEFAULT_MAX_HOST ? DEFAULT_MAX_HOST : quantity;
    },
    disableDownSell() {
      // Check account MRR > 500?
      return this.basicConfig.downSellData.disableDownSell;
    },
    decreaseTips() {
      if (this.selectedNumber === this.previousQuantity) {
        if (this.disableDownSell) {
          return this.$t('billing.error.can_not_bought_plan_tips');
        }
        if (this.forNonStandardPriceTips) {
          return this.forNonStandardPriceTips;
        }
      }

      return "";
    },
    additionalSpans() {
      return {
        zwb: [
          {
            value: 1,
            text: '',
          },
          {
            value: this.maxHosts,
            text: this.$t('billing.zone.max_of_plans', [this.maxHosts, this.maxHosts + 1]),
          },
        ],
      }
    }
  },
  watch: {
    selectedPlan: {
      handler() {
        this.$nextTick(() => {
          this.mx_validDownSellLicense(this.selectedNumber);
        });
      },
      deep: true
    }
  },
  methods: {
    async handleViewDetails() {
      await this.showSwitchPlanDialog();
    }
  }
};
</script>
